<template>
  <div class="car-content car-main-tab-content car-reduced-width">
    <back-btn @click="gobackToBookingDetail()" data-js="back" />
    <spinner v-if="loading" class="car-spinner car-main-content-spinner" />

    <div class="car-booking car-cancel-booking" v-else-if="booking.status === 'CANCELLED'">
      <div class="car-content-introduction car-reduced-width">
        <span class="car-headline">{{ $t('booking.canceled.title') }}</span>
        <p>{{ $t('booking.canceled.description') }}</p>
      </div>
      <div class="car-form-container">
        <div class="car-form-item">
          <label>{{ $t('booking.canceled.reasonLabel') }}:</label>
          <p>{{booking.comment}}</p>
        </div>
      </div>
    </div>
    <div class="car-booking car-cancel-booking" v-else-if="!loading">
      <div class="car-content-introduction car-reduced-width">
        <span class="car-headline">{{ $t('booking.willCancel.title') }}</span>
        <p>{{ $t('booking.willCancel.description', {firstname: booking.givenname || '', lastname: booking.surname || ''}) }}</p>
      </div>

      <label>{{$t('booking.reasonLabel')}}*</label>
      <div v-for='reason in reasonList'
         class="car-form-item"
         :key="reason">
        <checkbox :label="$t(`booking.reasons.${reason}`)"
                  @onClick="setSelectedReason(reason)"
                  :is-selected="reason === selectedReason"/>
      </div>

      <div class="car-form-item" v-if="selectedReason === 'comment'">
        <label>{{$t('booking.differentReason')}}*</label>
        <textarea
          type="text"
          rows="3"
          id="message"
          data-js="message__input"
          v-model="reasonText"
          v-bind:placeholder="$t('booking.otherReasonPlaceholder')" />
      </div>

      <div class="car-error-message" v-if="$v.$invalid && $v.$dirty">{{$t('booking.cancelReasonRequired')}}</div>
      <div class="car-form-buttons car-buttons">
        <primary-btn
          v-if="!loading"
          @click="declineBooking"
          data-js="confirm__cancel"
          class="car-btn-primary"
          id="booking">
          {{$t('booking.button.confirmCancel')}}
        </primary-btn>
        <button class="car-btn car-btn-default"
             @click="gobackToBookingDetail()">{{ $t('booking.button.cancelCancellation') }}
        </button>
        <div class="car-form-required">* {{ $t('catalogSelection.requiredNote') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import bookingApiService from '@/services/bookingApiService';
import PrimaryBtn from '@/components/PrimaryBtn';
import Checkbox from '@/components/Checkbox';
import BackBtn from '@/components/BackBtn';

const { required } = require('vuelidate/lib/validators');
export default {
  name: 'BookedOffer',
  data: function () {
    return {
      requestError: false,
      loading: false,
      selectedReason: '',
      reasonText: '',
      reasonList: [
        'client_no_time',
        'high_price',
        'found_other_dealer',
        'comment'
      ],
      displayPostponeAppointment: false
    }
  },
  validations() {
    let validationObj = {
      reasonText: {
        required
      },
      selectedReason: {
        required
      }
    };
    // make sure comment is not send as reason; if comment is selected reasonText has to be send
    if (this.selectedReason !== 'comment') {
      delete validationObj.reasonText;
    }
    return validationObj;
  },
  methods: {
    setSelectedReason: function(reason) {
      this.reasonText = '';
      this.selectedReason = reason;
    },
    validateForm: function() {
      this.$v.$touch();
    },
    declineBooking: function () {
      this.validateForm();
      if (this.$v.$invalid || this.loading) {
        return;
      }
      this.updateStatus({
        newStatus: 'CANCELLED',
        comment: this.reasonText || this.$t(`booking.reasons.${this.selectedReason}`)
      });
    },
    gobackToBookingDetail: function () {
      this.$router.push({
        path: `/booking/${this.booking.key}`
      });
    },
    updateStatus: function (params) {
      this.loading = true;
      return bookingApiService.updateStatus(this.booking.key, params).then(() => {
        this.$router.push({
          path: '/service-request/rejected'
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  computed: {
    booking() {
      return this.$store.getters['offer/booking'];
    }
  },
  created() {
    let bookedOfferKey = this.$route.params.key;
    if (bookedOfferKey !== this.booking.key) {
      this.loading = true;
      let promises = [
        this.$store.dispatch('serviceCase/getCaseByBookedOfferKey', bookedOfferKey),
        this.$store.dispatch('offer/getBookingDetails', bookedOfferKey)
      ];
      Promise.all(promises).finally(() => {
        this.loading = false;
      });
    }
  },
  components: {
    PrimaryBtn,
    Spinner,
    Checkbox,
    BackBtn
  }
};
</script>
